export default __webpack_public_path__ + "static/media/step_A_UA.090df9f4.png";